import { ActionWithError2, ActionWithErrorCreator2, ActionWithPayload2, ActionWithPayloadCreator2 } from "../../framework/action";
import { LOAD_ANNUAL_FINALS, LOAD_ANNUAL_FINALS_FAILED, LOAD_ANNUAL_FINALS_SUCCESS } from "./actionTypes";
import { AnnualFinals } from "./models";

export interface LoadAnnualFinals extends ActionWithPayload2<typeof LOAD_ANNUAL_FINALS, { year: string }> { }

export interface LoadAnnualFinalsSuccess extends ActionWithPayload2<typeof LOAD_ANNUAL_FINALS_SUCCESS, { annualFinals: AnnualFinals }> { }

export interface LoadAnnualFinalsFailed extends ActionWithError2<typeof LOAD_ANNUAL_FINALS_FAILED> { }

export const loadAnnualFinals: ActionWithPayloadCreator2<LoadAnnualFinals> = (payload) => ({ type: "LOAD_ANNUAL_FINALS", payload });
export const loadAnnualFinalsFailed: ActionWithErrorCreator2<LoadAnnualFinalsFailed> = (error) => ({ type: "LOAD_ANNUAL_FINALS_FAILED", error, description: "Nie udało nam się załadować klasyfikacji do finałów rocznych. Przeładuj stronę i spróbuj ponownie." });
export const loadAnnualFinalsSuccess: ActionWithPayloadCreator2<LoadAnnualFinalsSuccess> = (payload) => ({ type: "LOAD_ANNUAL_FINALS_SUCCESS", payload });

export type Actions =
    | LoadAnnualFinals
    | LoadAnnualFinalsFailed
    | LoadAnnualFinalsSuccess;
